import { createActionTypeModel } from "../../../../store/global/action-model";

export const VenueData = createActionTypeModel('VenueData');
export const VenueList = createActionTypeModel('VenueList');
export const VenueDetails = createActionTypeModel('VenueDetails');



// BOOKING_VENUES Action Types

export const GET_BOOKING_VENUES = 'GET_BOOKING_VENUES';
export const FETCH_BOOKING_VENUES = 'FETCH_BOOKING_VENUES';
export const SET_BOOKING_VENUES = 'SET_BOOKING_VENUES';
export const INSERT_BOOKING_VENUES = 'INSERT_BOOKING_VENUES';
export const UPDATE_BOOKING_VENUES = 'UPDATE_BOOKING_VENUES';
export const DELETE_BOOKING_VENUES = 'DELETE_BOOKING_VENUES';

export const SEARCH_VENUES = 'SEARCH_VENUES';
export const INSERT_VENUE = 'INSERT_VENUE';

export const SET_VENUE_START_ROW= 'SET_VENUE_START_ROW';


// SELECTED_VENUE Action Types

export const GET_SELECTED_VENUE = 'GET_SELECTED_VENUE';
export const FETCH_SELECTED_VENUE = 'FETCH_SELECTED_VENUE';
export const SET_SELECTED_VENUE = 'SET_SELECTED_VENUE';
export const INSERT_SELECTED_VENUE = 'INSERT_SELECTED_VENUE';
export const UPDATE_SELECTED_VENUE = 'UPDATE_SELECTED_VENUE';
export const DELETE_SELECTED_VENUE = 'DELETE_SELECTED_VENUE';



// VENUE_DETAILS_FLAG Action Types

export const GET_VENUE_DETAILS_FLAG = 'GET_VENUE_DETAILS_FLAG';
export const FETCH_VENUE_DETAILS_FLAG = 'FETCH_VENUE_DETAILS_FLAG';
export const SET_VENUE_DETAILS_FLAG = 'SET_VENUE_DETAILS_FLAG';
export const INSERT_VENUE_DETAILS_FLAG = 'INSERT_VENUE_DETAILS_FLAG';
export const UPDATE_VENUE_DETAILS_FLAG = 'UPDATE_VENUE_DETAILS_FLAG';
export const DELETE_VENUE_DETAILS_FLAG = 'DELETE_VENUE_DETAILS_FLAG';


export const SET_SELECTED_VENUE_LOADING = 'SET_SELECTED_VENUE_LOADING';


export const VENUE_LOCATION = createActionTypeModel('VENUE_LOCATION');
export const VENUE_RELATED_CONTACTS = createActionTypeModel('VENUE_RELATED_CONTACTS');
export const VENUE_FILES = createActionTypeModel('VENUE_FILES');
export const VENUE_FEATURES = createActionTypeModel('VENUE_FEATURES');
export const VENUE_GENRES = createActionTypeModel('VENUE_GENRES');
export const VENUE_EVENTS = createActionTypeModel('VENUE_EVENTS');

export const SET_VENUE_LOCATION_COMMENTS = 'SET_VENUE_LOCATION_COMMENTS';
export const DELETE_VENUE_LOCATION_COMMENTS = 'DELETE_VENUE_LOCATION_COMMENTS';

// SELECTED_VENUE_DATA Action Types
export const UPDATE_VENUE_CUSTOM_FIELD = 'UPDATE_VENUE_CUSTOM_FIELD';